import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function toggleRsvp(eventId) {
  const { data } = await axios.post(`${API}/events/${eventId}/rsvp`, {}, { withCredentials: true });
  return data; // { going, attendees }
}
export async function listAttendees(eventId) {
  const { data } = await axios.get(`${API}/events/${eventId}/rsvps`, { withCredentials: true });
  return data; // { attendees, count }
}
export async function broadcastToEvent(eventId, message) {
  const { data } = await axios.post(`${API}/events/${eventId}/broadcast`, { message }, { withCredentials: true });
  return data; // { sent }
}
